module.exports = __webpack_public_path__ + "static/fipcpinkcloud2-00bffa684de4e6ae27cbdcaf0d882611.jpeg";